import * as $ from 'jquery';
import * as _ from 'underscore';

import BaseStore from '../BaseStore';
import { Constants } from './Constants';
import { config } from '../../../../pdc-platform/src/ts/config';
import { Dispatcher } from './Dispatcher';
import { Action, Actions, I, check as checkAction } from './Actions';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';

export interface IStateFonts {
    fonts: any[];
    loadingFonts: boolean;
}

export class Store extends BaseStore<IStateFonts, Actions, Dispatcher, IGlob> {
    public static _name = 'fonts-store';

    private static getInitialState() {
        var state: IStateFonts = {
            fonts: [],
            loadingFonts: false
        };

        return state;
    }

    public _state: IStateFonts = Store.getInitialState();

    private loadFonts() {
        if (this._state.fonts.length !== 0) {
            return;
        }

        if (config.GOOGLE_FONTS_API_KEY == null) {
            this.glob.AppActions.showNotification_Fail('GOOGLE_FONTS_API_KEY is not specified.');
            return;
        }

        this._state.loadingFonts = true;

        var def = $.ajax({
            type: 'GET',
            url: 'https://www.googleapis.com/webfonts/v1/webfonts?sort=popularity&key=' + config.GOOGLE_FONTS_API_KEY
        });

        def.done((resp) => {
            this._state.fonts = resp.items;
        });

        def.fail((resp) => {
            this.glob.AppActions.showNotification_Fail('Google Fonts are not loaded.');
            //this._state.fonts = GOOGLE_FONTS;
        });

        def.always(() => {
            this.actions.loadFontsFinish();
        });
    }

    private loadFontsFinish() {
        this._state.loadingFonts = false;
    }

    protected eventsHandler(payload) {
        if (!super.eventsHandler(payload)) {
            return false;
        }

        const action = payload.action;

        switch (action.actionType) {
            case Constants.LOAD_FONTS:
                this.loadFonts();
                this.emitChange();
                break;

            case Constants.LOAD_FONTS_FINISH:
                this.loadFontsFinish();
                this.emitChange();
                break;
        }

        return true;
    }

    constructor(glob, dispatcher: Dispatcher, actions: Actions) {
        super(glob, dispatcher, actions, Store._name, true);
    }

    static get(glob, dispatcher: Dispatcher, actions: Actions) {
        return new Store(glob, dispatcher, actions);
    }
}

// const GOOGLE_FONTS = [
//     { "family": "Roboto" },
//     { "family": "Open Sans" },
//     { "family": "Lato" },
//     { "family": "Montserrat" },
//     { "family": "Roboto Condensed" },
//     { "family": "Source Sans Pro" },
//     { "family": "Oswald" },
//     { "family": "Raleway" },
//     { "family": "Roboto Mono" },
//     { "family": "Poppins" },
//     { "family": "Roboto Slab" },
//     { "family": "Merriweather" },
//     { "family": "Noto Sans" },
//     { "family": "PT Sans" },
//     { "family": "Ubuntu" },
//     { "family": "Playfair Display" },
//     { "family": "Open Sans Condensed" },
//     { "family": "Muli" },
//     { "family": "PT Serif" },
//     { "family": "Lora" },
//     { "family": "Slabo 27px" },
//     { "family": "Nunito" },
//     { "family": "Fira Sans" },
//     { "family": "Titillium Web" },
//     { "family": "Noto Sans JP" },
//     { "family": "Rubik" },
//     { "family": "Work Sans" },
//     { "family": "Noto Serif" },
//     { "family": "Nanum Gothic" },
//     { "family": "PT Sans Narrow" },
//     { "family": "Noto Sans KR" },
//     { "family": "Arimo" },
//     { "family": "Quicksand" },
//     { "family": "Inconsolata" },
//     { "family": "Nunito Sans" },
//     { "family": "Dosis" },
//     { "family": "Oxygen" },
//     { "family": "Heebo" },
//     { "family": "Noto Sans TC" },
//     { "family": "Cabin" },
//     { "family": "Libre Baskerville" },
//     { "family": "Karla" },
//     { "family": "Bitter" },
//     { "family": "Josefin Sans" },
//     { "family": "Crimson Text" },
//     { "family": "Libre Franklin" },
//     { "family": "Hind" },
//     { "family": "Source Code Pro" },
//     { "family": "Varela Round" },
//     { "family": "Indie Flower" },
//     { "family": "Anton" },
//     { "family": "Lobster" },
//     { "family": "Mukta" },
//     { "family": "Fjalla One" },
//     { "family": "Barlow" },
//     { "family": "Abel" },
//     { "family": "Yanone Kaffeesatz" },
//     { "family": "Dancing Script" },
//     { "family": "Arvo" },
//     { "family": "Pacifico" },
//     { "family": "Source Serif Pro" },
//     { "family": "Exo 2" },
//     { "family": "Merriweather Sans" },
//     { "family": "Shadows Into Light" },
//     { "family": "Asap" },
//     { "family": "Archivo Narrow" },
//     { "family": "Overpass" },
//     { "family": "Questrial" },
//     { "family": "Bree Serif" },
//     { "family": "Abril Fatface" },
//     { "family": "Barlow Condensed" },
//     { "family": "Teko" },
//     { "family": "Acme" },
//     { "family": "EB Garamond" },
//     { "family": "Barlow Semi Condensed" },
//     { "family": "Exo" },
//     { "family": "Comfortaa" },
//     { "family": "IBM Plex Sans" },
//     { "family": "Kanit" },
//     { "family": "Amatic SC" },
//     { "family": "Signika" },
//     { "family": "Cairo" },
//     { "family": "Hind Siliguri" },
//     { "family": "Maven Pro" },
//     { "family": "Play" },
//     { "family": "Fira Sans Condensed" },
//     { "family": "Ubuntu Condensed" },
//     { "family": "Catamaran" },
//     { "family": "Righteous" },
//     { "family": "Assistant" },
//     { "family": "Noto Sans SC" },
//     { "family": "Domine" },
//     { "family": "PT Sans Caption" },
//     { "family": "Ropa Sans" },
//     { "family": "Prompt" },
//     { "family": "Vollkorn" },
//     { "family": "Crete Round" },
//     { "family": "Cinzel" },
//     { "family": "Permanent Marker" },
//     { "family": "Patua One" },
//     { "family": "Cuprum" },
//     { "family": "ABeeZee" },
//     { "family": "Francois One" },
//     { "family": "Rajdhani" },
//     { "family": "News Cycle" },
//     { "family": "Cormorant Garamond" },
//     { "family": "Hind Madurai" },
//     { "family": "Caveat" },
//     { "family": "Rokkitt" },
//     { "family": "Monda" },
//     { "family": "Pathway Gothic One" },
//     { "family": "Courgette" },
//     { "family": "Amiri" },
//     { "family": "Fredoka One" },
//     { "family": "Satisfy" },
//     { "family": "Zilla Slab" },
//     { "family": "Alegreya Sans" },
//     { "family": "Martel" },
//     { "family": "Alegreya" },
//     { "family": "Kalam" },
//     { "family": "Fira Sans Extra Condensed" },
//     { "family": "Noticia Text" },
//     { "family": "Alfa Slab One" },
//     { "family": "Istok Web" },
//     { "family": "Tinos" },
//     { "family": "Saira Extra Condensed" },
//     { "family": "Tajawal" },
//     { "family": "Kaushan Script" },
//     { "family": "Cardo" },
//     { "family": "Nanum Myeongjo" },
//     { "family": "Great Vibes" },
//     { "family": "Cantarell" },
//     { "family": "Archivo Black" },
//     { "family": "Didact Gothic" },
//     { "family": "Old Standard TT" },
//     { "family": "Patrick Hand" },
//     { "family": "Sacramento" },
//     { "family": "Vidaloka" },
//     { "family": "Quattrocento Sans" },
//     { "family": "Orbitron" },
//     { "family": "IBM Plex Serif" },
//     { "family": "Lobster Two" },
//     { "family": "Luckiest Guy" },
//     { "family": "Frank Ruhl Libre" },
//     { "family": "Advent Pro" },
//     { "family": "Gloria Hallelujah" },
//     { "family": "Cookie" },
//     { "family": "Baloo Bhai" },
//     { "family": "Hind Vadodara" },
//     { "family": "Volkhov" },
//     { "family": "Gothic A1" },
//     { "family": "Concert One" },
//     { "family": "Quattrocento" },
//     { "family": "M PLUS 1p" },
//     { "family": "Economica" },
//     { "family": "Sanchez" },
//     { "family": "Noto Serif JP" },
//     { "family": "Neuton" },
//     { "family": "Poiret One" },
//     { "family": "Sunflower" },
//     { "family": "Playfair Display SC" },
//     { "family": "Hind Guntur" },
//     { "family": "Passion One" },
//     { "family": "BenchNine" },
//     { "family": "Josefin Slab" },
//     { "family": "Prata" },
//     { "family": "Russo One" },
//     { "family": "Neucha" },
//     { "family": "Chivo" },
//     { "family": "Changa" },
//     { "family": "Archivo" },
//     { "family": "Handlee" },
//     { "family": "Lalezar" },
//     { "family": "Gudea" },
//     { "family": "Yantramanav" },
//     { "family": "Bangers" },
//     { "family": "Ruda" },
//     { "family": "Ultra" },
//     { "family": "Asap Condensed" },
//     { "family": "Parisienne" },
//     { "family": "Special Elite" },
//     { "family": "Yrsa" },
//     { "family": "Paytone One" },
//     { "family": "Philosopher" },
//     { "family": "Armata" },
//     { "family": "Sawarabi Mincho" },
//     { "family": "Squada One" },
//     { "family": "Montserrat Alternates" },
//     { "family": "Monoton" },
//     { "family": "Cabin Condensed" },
//     { "family": "Architects Daughter" },
//     { "family": "Varela" },
//     { "family": "Khand" },
//     { "family": "Nanum Gothic Coding" },
//     { "family": "Taviraj" },
//     { "family": "Pontano Sans" },
//     { "family": "Enriqueta" },
//     { "family": "Alice" },
//     { "family": "Arapey" },
//     { "family": "Marck Script" },
//     { "family": "Unica One" },
//     { "family": "Hammersmith One" },
//     { "family": "Spectral" },
//     { "family": "Yellowtail" },
//     { "family": "PT Mono" },
//     { "family": "Gentium Basic" },
//     { "family": "Saira Condensed" },
//     { "family": "Amaranth" },
//     { "family": "Bowlby One SC" },
//     { "family": "Damion" },
//     { "family": "Merienda" },
//     { "family": "Viga" },
//     { "family": "Adamina" },
//     { "family": "Tangerine" },
//     { "family": "Audiowide" },
//     { "family": "Gentium Book Basic" },
//     { "family": "M PLUS Rounded 1c" },
//     { "family": "Cantata One" },
//     { "family": "Candal" },
//     { "family": "Bad Script" },
//     { "family": "Sarabun" },
//     { "family": "Glegoo" },
//     { "family": "Karma" },
//     { "family": "Sigmar One" },
//     { "family": "Staatliches" },
//     { "family": "El Messiri" },
//     { "family": "Saira" },
//     { "family": "Signika Negative" },
//     { "family": "Actor" },
//     { "family": "Fugaz One" },
//     { "family": "Rasa" },
//     { "family": "Homemade Apple" },
//     { "family": "Mitr" },
//     { "family": "Pragati Narrow" },
//     { "family": "Antic" },
//     { "family": "Julius Sans One" },
//     { "family": "Gochi Hand" },
//     { "family": "Sorts Mill Goudy" },
//     { "family": "Press Start 2P" },
//     { "family": "Shadows Into Light Two" },
//     { "family": "Kreon" },
//     { "family": "Ubuntu Mono" },
//     { "family": "Scada" },
//     { "family": "Lusitana" },
//     { "family": "Playball" },
//     { "family": "Saira Semi Condensed" },
//     { "family": "Sarala" },
//     { "family": "Pridi" },
//     { "family": "Rock Salt" },
//     { "family": "Allura" },
//     { "family": "Unna" },
//     { "family": "Oleo Script" },
//     { "family": "Cormorant" },
//     { "family": "Yeseva One" },
//     { "family": "Sintony" },
//     { "family": "Boogaloo" },
//     { "family": "Carter One" },
//     { "family": "Jura" },
//     { "family": "Electrolize" },
//     { "family": "Covered By Your Grace" },
//     { "family": "Nanum Pen Script" },
//     { "family": "Baloo" },
//     { "family": "Coming Soon" },
//     { "family": "PT Serif Caption" },
//     { "family": "Reenie Beanie" },
//     { "family": "Quantico" },
//     { "family": "Alegreya Sans SC" },
//     { "family": "Khula" },
//     { "family": "Marvel" },
//     { "family": "Fauna One" },
//     { "family": "Arbutus Slab" },
//     { "family": "Tenor Sans" },
//     { "family": "Coda Caption" },
//     { "family": "Chewy" },
//     { "family": "Rancho" },
//     { "family": "Pinyon Script" },
//     { "family": "Abhaya Libre" },
//     { "family": "Jaldi" },
//     { "family": "Alex Brush" },
//     { "family": "Forum" },
//     { "family": "Nothing You Could Do" },
//     { "family": "Coda" },
//     { "family": "Rubik Mono One" },
//     { "family": "Marcellus" },
//     { "family": "Palanquin" },
//     { "family": "Antic Slab" },
//     { "family": "Sawarabi Gothic" },
//     { "family": "Spinnaker" },
//     { "family": "Lustria" },
//     { "family": "Mr Dafoe" },
//     { "family": "Encode Sans Condensed" },
//     { "family": "Michroma" },
//     { "family": "Marmelad" },
//     { "family": "Bevan" },
//     { "family": "Black Ops One" },
//     { "family": "Reem Kufi" },
//     { "family": "Aclonica" },
//     { "family": "Alef" },
//     { "family": "Caveat Brush" },
//     { "family": "IBM Plex Mono" },
//     { "family": "Molengo" },
//     { "family": "Aldrich" },
//     { "family": "Knewave" },
//     { "family": "Merienda One" },
//     { "family": "Niconne" },
//     { "family": "Rambla" },
//     { "family": "Cousine" },
//     { "family": "Basic" },
//     { "family": "Average" },
//     { "family": "Share Tech Mono" },
//     { "family": "VT323" },
//     { "family": "Markazi Text" },
//     { "family": "Kosugi Maru" },
//     { "family": "Days One" },
//     { "family": "Mukta Malar" },
//     { "family": "Fredericka the Great" },
//     { "family": "Cabin Sketch" },
//     { "family": "Halant" },
//     { "family": "Baloo Bhaina" },
//     { "family": "Nobile" },
//     { "family": "Biryani" },
//     { "family": "Allerta" },
//     { "family": "Italianno" },
//     { "family": "Cedarville Cursive" },
//     { "family": "Rufina" },
//     { "family": "Overlock" },
//     { "family": "Pangolin" },
//     { "family": "Aladin" },
//     { "family": "DM Sans" },
//     { "family": "DM Serif Text" },
//     { "family": "McLaren" },
//     { "family": "Fira Mono" },
//     { "family": "Arima Madurai" },
//     { "family": "Allerta Stencil" },
//     { "family": "Lateef" },
//     { "family": "Encode Sans" },
//     { "family": "Just Another Hand" },
//     { "family": "Leckerli One" },
//     { "family": "Lilita One" },
//     { "family": "Syncopate" },
//     { "family": "Scheherazade" },
//     { "family": "Fondamento" },
//     { "family": "Space Mono" },
//     { "family": "Norican" },
//     { "family": "Itim" },
//     { "family": "Ramabhadra" },
//     { "family": "Hanuman" },
//     { "family": "Telex" },
//     { "family": "Gruppo" },
//     { "family": "Galada" },
//     { "family": "Miriam Libre" },
//     { "family": "Arsenal" },
//     { "family": "Noto Serif SC" },
//     { "family": "Lemonada" },
//     { "family": "Cinzel Decorative" },
//     { "family": "Share" },
//     { "family": "Oranienbaum" },
//     { "family": "Anonymous Pro" },
//     { "family": "Mountains of Christmas" },
//     { "family": "Berkshire Swash" },
//     { "family": "Montserrat Subrayada" },
//     { "family": "Marcellus SC" },
//     { "family": "Annie Use Your Telescope" },
//     { "family": "Copse" },
//     { "family": "Grand Hotel" },
//     { "family": "Kameron" },
//     { "family": "Allan" },
//     { "family": "Martel Sans" },
//     { "family": "Lekton" },
//     { "family": "Rochester" },
//     { "family": "Nanum Brush Script" },
//     { "family": "Judson" },
//     { "family": "Shrikhand" },
//     { "family": "Bai Jamjuree" },
//     { "family": "Magra" },
//     { "family": "Londrina Solid" },
//     { "family": "Alegreya SC" },
//     { "family": "Mada" },
//     { "family": "Radley" },
//     { "family": "Noto Serif TC" },
//     { "family": "Buenard" },
//     { "family": "Racing Sans One" },
//     { "family": "Jockey One" },
//     { "family": "Caudex" },
//     { "family": "Changa One" },
//     { "family": "Yesteryear" },
//     { "family": "Eczar" },
//     { "family": "Carrois Gothic" },
//     { "family": "Trirong" },
//     { "family": "Bentham" },
//     { "family": "Nixie One" },
//     { "family": "Modak" },
//     { "family": "Krub" },
//     { "family": "Aleo" },
//     { "family": "Contrail One" },
//     { "family": "Graduate" },
//     { "family": "Petit Formal Script" },
//     { "family": "Pattaya" },
//     { "family": "Suranna" },
//     { "family": "Slabo 13px" },
//     { "family": "Encode Sans Semi Condensed" },
//     { "family": "Mali" },
//     { "family": "Gilda Display" },
//     { "family": "Voltaire" },
//     { "family": "Carme" },
//     { "family": "Niramit" },
//     { "family": "Sue Ellen Francisco" },
//     { "family": "Coustard" },
//     { "family": "Baloo Bhaijaan" },
//     { "family": "Overpass Mono" },
//     { "family": "Titan One" },
//     { "family": "Bungee Inline" },
//     { "family": "ZCOOL XiaoWei" },
//     { "family": "Palanquin Dark" },
//     { "family": "Rosario" },
//     { "family": "Herr Von Muellerhoff" },
//     { "family": "Bungee" },
//     { "family": "Belleza" },
//     { "family": "Calligraffitti" },
//     { "family": "Capriola" },
//     { "family": "Kelly Slab" },
//     { "family": "Love Ya Like A Sister" },
//     { "family": "Bubblegum Sans" },
//     { "family": "Sriracha" },
//     { "family": "Metrophobic" },
//     { "family": "Kristi" },
//     { "family": "Encode Sans Expanded" },
//     { "family": "GFS Didot" },
//     { "family": "Shojumaru" },
//     { "family": "Maitree" },
//     { "family": "Arizonia" },
//     { "family": "Average Sans" },
//     { "family": "Schoolbell" },
//     { "family": "Faustina" },
//     { "family": "Oxygen Mono" },
//     { "family": "Rye" },
//     { "family": "Mukta Vaani" },
//     { "family": "Six Caps" },
//     { "family": "Goudy Bookletter 1911" },
//     { "family": "Andada" },
//     { "family": "Poly" },
//     { "family": "Trade Winds" },
//     { "family": "Delius" },
//     { "family": "Red Hat Text" },
//     { "family": "DM Serif Display" },
//     { "family": "Cambay" },
//     { "family": "Cutive" },
//     { "family": "Red Hat Display" },
//     { "family": "Chakra Petch" },
//     { "family": "Cutive Mono" },
//     { "family": "Cambo" },
//     { "family": "Limelight" },
//     { "family": "Duru Sans" },
//     { "family": "Ceviche One" },
//     { "family": "Freckle Face" },
//     { "family": "Lexend Deca" },
//     { "family": "Mr De Haviland" },
//     { "family": "Ovo" },
//     { "family": "Pompiere" },
//     { "family": "Anaheim" },
//     { "family": "IBM Plex Sans Condensed" },
//     { "family": "Trocchi" },
//     { "family": "Vesper Libre" },
//     { "family": "Black Han Sans" },
//     { "family": "Amethysta" },
//     { "family": "Laila" },
//     { "family": "Unkempt" },
//     { "family": "Corben" },
//     { "family": "Federo" },
//     { "family": "Athiti" },
//     { "family": "Sansita" },
//     { "family": "IM Fell English" },
//     { "family": "Inder" },
//     { "family": "Kadwa" },
//     { "family": "Cormorant Infant" },
//     { "family": "IM Fell Double Pica" },
//     { "family": "Secular One" },
//     { "family": "Encode Sans Semi Expanded" },
//     { "family": "Baumans" },
//     { "family": "Emilys Candy" },
//     { "family": "Battambang" },
//     { "family": "Suez One" },
//     { "family": "Mate" },
//     { "family": "Montez" },
//     { "family": "Chonburi" },
//     { "family": "Homenaje" },
//     { "family": "Doppio One" },
//     { "family": "Convergence" },
//     { "family": "Brawler" },
//     { "family": "Do Hyeon" },
//     { "family": "Fanwood Text" },
//     { "family": "Gabriela" },
//     { "family": "Finger Paint" },
//     { "family": "Averia Serif Libre" },
//     { "family": "Noto Serif KR" },
//     { "family": "Lemon" },
//     { "family": "Oregano" },
//     { "family": "Mouse Memoirs" },
//     { "family": "Gurajada" },
//     { "family": "Amiko" },
//     { "family": "Chelsea Market" },
//     { "family": "Balthazar" },
//     { "family": "Seaweed Script" },
//     { "family": "Big Shoulders Text" },
//     { "family": "Alike" },
//     { "family": "Crafty Girls" },
//     { "family": "Vast Shadow" },
//     { "family": "Raleway Dots" },
//     { "family": "Gravitas One" },
//     { "family": "Megrim" },
//     { "family": "Fresca" },
//     { "family": "Short Stack" },
//     { "family": "Aref Ruqaa" },
//     { "family": "La Belle Aurore" },
//     { "family": "Rouge Script" },
//     { "family": "IM Fell DW Pica" },
//     { "family": "Skranji" },
//     { "family": "Mallanna" },
//     { "family": "UnifrakturMaguntia" },
//     { "family": "BioRhyme" },
//     { "family": "Cormorant SC" },
//     { "family": "Carrois Gothic SC" },
//     { "family": "Kurale" },
//     { "family": "Sofia" },
//     { "family": "Bowlby One" },
//     { "family": "Sniglet" },
//     { "family": "Belgrano" },
//     { "family": "Stardos Stencil" },
//     { "family": "Spicy Rice" },
//     { "family": "Denk One" },
//     { "family": "Patrick Hand SC" },
//     { "family": "Faster One" },
//     { "family": "Baloo Da" },
//     { "family": "IM Fell English SC" },
//     { "family": "Qwigley" },
//     { "family": "Give You Glory" },
//     { "family": "Clicker Script" },
//     { "family": "Rozha One" },
//     { "family": "Jua" },
//     { "family": "Waiting for the Sunrise" },
//     { "family": "Wallpoet" },
//     { "family": "Quando" },
//     { "family": "Share Tech" },
//     { "family": "Zeyada" },
//     { "family": "Nova Square" },
//     { "family": "Strait" },
//     { "family": "Kosugi" },
//     { "family": "Gafata" },
//     { "family": "Expletus Sans" },
//     { "family": "Podkova" },
//     { "family": "Andika" },
//     { "family": "Harmattan" },
//     { "family": "Proza Libre" },
//     { "family": "Alike Angular" },
//     { "family": "Loved by the King" },
//     { "family": "Mirza" },
//     { "family": "Spectral SC" },
//     { "family": "Amita" },
//     { "family": "Esteban" },
//     { "family": "Aguafina Script" },
//     { "family": "Just Me Again Down Here" },
//     { "family": "Oleo Script Swash Caps" },
//     { "family": "Meddon" },
//     { "family": "Sedgwick Ave" },
//     { "family": "Puritan" },
//     { "family": "Katibeh" },
//     { "family": "Voces" },
//     { "family": "Cherry Swash" },
//     { "family": "Baloo Thambi" },
//     { "family": "Baloo Chettan" },
//     { "family": "Poller One" },
//     { "family": "NTR" },
//     { "family": "Mako" },
//     { "family": "Scope One" },
//     { "family": "Averia Sans Libre" },
//     { "family": "Walter Turncoat" },
//     { "family": "Noto Sans HK" },
//     { "family": "Koulen" },
//     { "family": "Bilbo Swash Caps" },
//     { "family": "Happy Monkey" },
//     { "family": "Literata" },
//     { "family": "Orienta" },
//     { "family": "Cantora One" },
//     { "family": "The Girl Next Door" },
//     { "family": "Cormorant Upright" },
//     { "family": "Rationale" },
//     { "family": "Overlock SC" },
//     { "family": "Mrs Saint Delafield" },
//     { "family": "Atma" },
//     { "family": "Tauri" },
//     { "family": "Fjord One" },
//     { "family": "Crushed" },
//     { "family": "Wendy One" },
//     { "family": "Libre Barcode 39" },
//     { "family": "Bungee Shade" },
//     { "family": "Krona One" },
//     { "family": "Dawning of a New Day" },
//     { "family": "Euphoria Script" },
//     { "family": "Holtwood One SC" },
//     { "family": "Charm" },
//     { "family": "Delius Swash Caps" },
//     { "family": "Fontdiner Swanky" },
//     { "family": "K2D" },
//     { "family": "Geo" },
//     { "family": "Mukta Mahee" },
//     { "family": "Over the Rainbow" },
//     { "family": "Tienne" },
//     { "family": "B612 Mono" },
//     { "family": "Sarpanch" },
//     { "family": "Iceland" },
//     { "family": "Rammetto One" },
//     { "family": "Life Savers" },
//     { "family": "Wire One" },
//     { "family": "Salsa" },
//     { "family": "Rum Raisin" },
//     { "family": "Artifika" },
//     { "family": "Spirax" },
//     { "family": "Bellefair" },
//     { "family": "Imprima" },
//     { "family": "Princess Sofia" },
//     { "family": "Ledger" },
//     { "family": "Lily Script One" },
//     { "family": "Codystar" },
//     { "family": "Creepster" },
//     { "family": "Mandali" },
//     { "family": "Underdog" },
//     { "family": "Port Lligat Sans" },
//     { "family": "Habibi" },
//     { "family": "Asul" },
//     { "family": "Shanti" },
//     { "family": "Bubbler One" },
//     { "family": "Nova Mono" },
//     { "family": "Englebert" },
//     { "family": "Vampiro One" },
//     { "family": "Numans" },
//     { "family": "Slackey" },
//     { "family": "Rakkas" },
//     { "family": "Padauk" },
//     { "family": "Pavanam" },
//     { "family": "Headland One" },
//     { "family": "Vibur" },
//     { "family": "Ranchers" },
//     { "family": "Prosto One" },
//     { "family": "Averia Libre" },
//     { "family": "Dokdo" },
//     { "family": "Baloo Paaji" },
//     { "family": "Amarante" },
//     { "family": "Eater" },
//     { "family": "Kranky" },
//     { "family": "Gugi" },
//     { "family": "Ruluko" },
//     { "family": "Manjari" },
//     { "family": "Antic Didone" },
//     { "family": "Ruslan Display" },
//     { "family": "Port Lligat Slab" },
//     { "family": "Dekko" },
//     { "family": "Coiny" },
//     { "family": "Medula One" },
//     { "family": "Mogra" },
//     { "family": "Frijole" },
//     { "family": "Peralta" },
//     { "family": "Sirin Stencil" },
//     { "family": "Livvic" },
//     { "family": "Almendra" },
//     { "family": "Elsie" },
//     { "family": "Kotta One" },
//     { "family": "Yatra One" },
//     { "family": "Zilla Slab Highlight" },
//     { "family": "Baloo Tamma" },
//     { "family": "Farsan" },
//     { "family": "Cherry Cream Soda" },
//     { "family": "Dynalight" },
//     { "family": "Khmer" },
//     { "family": "Sail" },
//     { "family": "Griffy" },
//     { "family": "David Libre" },
//     { "family": "Engagement" },
//     { "family": "Ranga" },
//     { "family": "Arya" },
//     { "family": "Metamorphous" },
//     { "family": "Kumar One" },
//     { "family": "ZCOOL QingKe HuangYou" },
//     { "family": "Manuale" },
//     { "family": "Sonsie One" },
//     { "family": "Saira Stencil One" },
//     { "family": "Inknut Antiqua" },
//     { "family": "Donegal One" },
//     { "family": "Mystery Quest" },
//     { "family": "Nokora" },
//     { "family": "Chathura" },
//     { "family": "Nova Round" },
//     { "family": "Stoke" },
//     { "family": "Mate SC" },
//     { "family": "Delius Unicase" },
//     { "family": "Dorsa" },
//     { "family": "Junge" },
//     { "family": "Meera Inimai" },
//     { "family": "Tulpen One" },
//     { "family": "Simonetta" },
//     { "family": "Prociono" },
//     { "family": "Macondo Swash Caps" },
//     { "family": "Condiment" },
//     { "family": "Rosarivo" },
//     { "family": "Germania One" },
//     { "family": "Darker Grotesque" },
//     { "family": "Sarina" },
//     { "family": "Buda" },
//     { "family": "Chau Philomene One" },
//     { "family": "Flamenco" },
//     { "family": "Mina" },
//     { "family": "Ramaraja" },
//     { "family": "Vollkorn SC" },
//     { "family": "Chicle" },
//     { "family": "Thasadith" },
//     { "family": "Stint Ultra Condensed" },
//     { "family": "Nova Slim" },
//     { "family": "Timmana" },
//     { "family": "Quintessential" },
//     { "family": "Moul" },
//     { "family": "Fascinate Inline" },
//     { "family": "IM Fell French Canon" },
//     { "family": "Gaegu" },
//     { "family": "Fenix" },
//     { "family": "Kite One" },
//     { "family": "Pirata One" },
//     { "family": "Bilbo" },
//     { "family": "Almarai" },
//     { "family": "Londrina Outline" },
//     { "family": "Stalemate" },
//     { "family": "Italiana" },
//     { "family": "IM Fell Great Primer" },
//     { "family": "Miniver" },
//     { "family": "Paprika" },
//     { "family": "League Script" },
//     { "family": "Ribeye Marrow" },
//     { "family": "Cagliostro" },
//     { "family": "Milonga" },
//     { "family": "Sura" },
//     { "family": "IM Fell DW Pica SC" },
//     { "family": "Akronim" },
//     { "family": "Sunshiney" },
//     { "family": "Henny Penny" },
//     { "family": "Ribeye" },
//     { "family": "Revalia" },
//     { "family": "Swanky and Moo Moo" },
//     { "family": "Srisakdi" },
//     { "family": "Jacques Francois Shadow" },
//     { "family": "Kavoon" },
//     { "family": "Ewert" },
//     { "family": "Sancreek" },
//     { "family": "Hanalei Fill" },
//     { "family": "Lovers Quarrel" },
//     { "family": "New Rocker" },
//     { "family": "Be Vietnam" },
//     { "family": "Sumana" },
//     { "family": "Text Me One" },
//     { "family": "Angkor" },
//     { "family": "Nosifer" },
//     { "family": "Libre Caslon Text" },
//     { "family": "Maiden Orange" },
//     { "family": "Della Respira" },
//     { "family": "Barriecito" },
//     { "family": "Uncial Antiqua" },
//     { "family": "Glass Antiqua" },
//     { "family": "Julee" },
//     { "family": "Croissant One" },
//     { "family": "Farro" },
//     { "family": "Averia Gruesa Libre" },
//     { "family": "Barrio" },
//     { "family": "Plaster" },
//     { "family": "Bokor" },
//     { "family": "Trochut" },
//     { "family": "Marko One" },
//     { "family": "Joti One" },
//     { "family": "Song Myung" },
//     { "family": "Petrona" },
//     { "family": "Hepta Slab" },
//     { "family": "Redressed" },
//     { "family": "Galdeano" },
//     { "family": "Sree Krushnadevaraya" },
//     { "family": "Big Shoulders Display" },
//     { "family": "Blinker" },
//     { "family": "Wellfleet" },
//     { "family": "Cormorant Unicase" },
//     { "family": "Margarine" },
//     { "family": "Autour One" },
//     { "family": "Grenze" },
//     { "family": "UnifrakturCook" },
//     { "family": "Linden Hill" },
//     { "family": "Offside" },
//     { "family": "Eagle Lake" },
//     { "family": "Tillana" },
//     { "family": "Diplomata" },
//     { "family": "Elsie Swash Caps" },
//     { "family": "Monsieur La Doulaise" },
//     { "family": "Kodchasan" },
//     { "family": "IM Fell French Canon SC" },
//     { "family": "Nova Flat" },
//     { "family": "B612" },
//     { "family": "Purple Purse" },
//     { "family": "Chela One" },
//     { "family": "Stint Ultra Expanded" },
//     { "family": "Content" },
//     { "family": "Chango" },
//     { "family": "Libre Barcode 39 Text" },
//     { "family": "Irish Grover" },
//     { "family": "Smythe" },
//     { "family": "Unlock" },
//     { "family": "Monofett" },
//     { "family": "Ruthie" },
//     { "family": "Charmonman" },
//     { "family": "Trykker" },
//     { "family": "Oldenburg" },
//     { "family": "Mrs Sheppards" },
//     { "family": "Bigshot One" },
//     { "family": "Inika" },
//     { "family": "Mansalva" },
//     { "family": "Notable" },
//     { "family": "Fahkwang" },
//     { "family": "Montaga" },
//     { "family": "Poor Story" },
//     { "family": "Arbutus" },
//     { "family": "Goblin One" },
//     { "family": "Chilanka" },
//     { "family": "Baloo Tammudu" },
//     { "family": "Stylish" },
//     { "family": "ZCOOL KuaiLe" },
//     { "family": "Metal Mania" },
//     { "family": "Fira Code" },
//     { "family": "Iceberg" },
//     { "family": "IM Fell Great Primer SC" },
//     { "family": "MedievalSharp" },
//     { "family": "Dr Sugiyama" },
//     { "family": "Molle" },
//     { "family": "KoHo" },
//     { "family": "Dangrek" },
//     { "family": "Modern Antiqua" },
//     { "family": "Suwannaphum" },
//     { "family": "Hi Melody" },
//     { "family": "Liu Jian Mao Cao" },
//     { "family": "Rhodium Libre" },
//     { "family": "Asset" },
//     { "family": "Lakki Reddy" },
//     { "family": "Felipa" },
//     { "family": "Caesar Dressing" },
//     { "family": "Original Surfer" },
//     { "family": "Sahitya" },
//     { "family": "Asar" },
//     { "family": "Libre Barcode 128" },
//     { "family": "Meie Script" },
//     { "family": "Devonshire" },
//     { "family": "Odor Mean Chey" },
//     { "family": "Bahiana" },
//     { "family": "Lancelot" },
//     { "family": "Ravi Prakash" },
//     { "family": "Keania One" },
//     { "family": "Bebas Neue" },
//     { "family": "IM Fell Double Pica SC" },
//     { "family": "Supermercado One" },
//     { "family": "Snowburst One" },
//     { "family": "Snippet" },
//     { "family": "Libre Barcode 39 Extended Text" },
//     { "family": "Crimson Pro" },
//     { "family": "Bayon" },
//     { "family": "Jolly Lodger" },
//     { "family": "Atomic Age" },
//     { "family": "Freehand" },
//     { "family": "Londrina Shadow" },
//     { "family": "Miltonian Tattoo" },
//     { "family": "Kantumruy" },
//     { "family": "Diplomata SC" },
//     { "family": "Astloch" },
//     { "family": "Gamja Flower" },
//     { "family": "Nova Cut" },
//     { "family": "Jim Nightshade" },
//     { "family": "Cute Font" },
//     { "family": "Gorditas" },
//     { "family": "Libre Barcode 39 Extended" },
//     { "family": "Smokum" },
//     { "family": "Kenia" },
//     { "family": "Flavors" },
//     { "family": "Major Mono Display" },
//     { "family": "Kavivanar" },
//     { "family": "Risque" },
//     { "family": "Ruge Boogie" },
//     { "family": "Bungee Hairline" },
//     { "family": "Jacques Francois" },
//     { "family": "Almendra Display" },
//     { "family": "GFS Neohellenic" },
//     { "family": "Miltonian" },
//     { "family": "Yeon Sung" },
//     { "family": "Siemreap" },
//     { "family": "Jomhuria" },
//     { "family": "East Sea Dokdo" },
//     { "family": "Nova Script" },
//     { "family": "Black And White Picture" },
//     { "family": "Butcherman" },
//     { "family": "Almendra SC" },
//     { "family": "Romanesco" },
//     { "family": "Nova Oval" },
//     { "family": "Seymour One" },
//     { "family": "Jomolhari" },
//     { "family": "Kirang Haerang" },
//     { "family": "Emblema One" },
//     { "family": "Piedra" },
//     { "family": "Bigelow Rules" },
//     { "family": "Macondo" },
//     { "family": "Bungee Outline" },
//     { "family": "Tenali Ramakrishna" },
//     { "family": "Butterfly Kids" },
//     { "family": "Combo" },
//     { "family": "Kumar One Outline" },
//     { "family": "Passero One" },
//     { "family": "Galindo" },
//     { "family": "Geostar Fill" },
//     { "family": "Miss Fajardose" },
//     { "family": "Sedgwick Ave Display" },
//     { "family": "Metal" },
//     { "family": "Fruktur" },
//     { "family": "Taprom" },
//     { "family": "Aubrey" },
//     { "family": "Bonbon" },
//     { "family": "Londrina Sketch" },
//     { "family": "Erica One" },
//     { "family": "Libre Barcode 128 Text" },
//     { "family": "Sevillana" },
//     { "family": "Chenla" },
//     { "family": "Mr Bedfort" },
//     { "family": "Fascinate" },
//     { "family": "Geostar" },
//     { "family": "Kdam Thmor" },
//     { "family": "Gidugu" },
//     { "family": "Sofadi One" },
//     { "family": "Hanalei" },
//     { "family": "Peddana" },
//     { "family": "Beth Ellen" },
//     { "family": "Preahvihear" },
//     { "family": "Suravaram" },
//     { "family": "Federant" },
//     { "family": "Lexend Exa" },
//     { "family": "Stalinist One" },
//     { "family": "Lexend Tera" },
//     { "family": "Moulpali" },
//     { "family": "Dhurjati" },
//     { "family": "Libre Caslon Display" },
//     { "family": "Fasthand" },
//     { "family": "BioRhyme Expanded" },
//     { "family": "Ma Shan Zheng" },
//     { "family": "Warnes" },
//     { "family": "Gayathri" },
//     { "family": "Turret Road" },
//     { "family": "Lacquer" },
//     { "family": "Single Day" },
//     { "family": "Lexend Zetta" },
//     { "family": "Public Sans" },
//     { "family": "Lexend Mega" },
//     { "family": "Lexend Giga" },
//     { "family": "Lexend Peta" },
//     { "family": "Zhi Mang Xing" },
//     { "family": "Tomorrow" },
//     { "family": "Long Cang" },
//     { "family": "Bahianita" },
//     { "family": "Vibes" },
//     { "family": "Kulim Park" },
//     { "family": "Alata" },
//     { "family": "Alatsi" },
//     { "family": "Odibee Sans" },
//     { "family": "Baskervville" },
//     { "family": "Calistoga" },
//     { "family": "Sulphur Point" },
//     { "family": "Ibarra Real Nova" },
//     { "family": "Solway" }
// ];
